import axios from "axios";
import { Response } from "@/shared/models/Response";
import { ViewsConfigResponse } from "../models/viewsConfigResponse";
import { DashboardTemplateListResponse } from "../models/DashboardTemplateListResponse";

export class BqDashboardService {
  private baseUrl: string;
  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/bg-dashboard`;
  }

  async getViesConfig(): Promise<Response<ViewsConfigResponse[]>> {
    const serviceURL = `${this.baseUrl}/bq-views-config`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getDataToChart(query: any): Promise<any> {
    try {
      const serviceURL = `${this.baseUrl}/bq-filters`;
      const response = await axios.post(serviceURL, query);
      return response.data;
    } catch (error) {
      console.error("Error getDataToChart en el servicio -->", error);
    }
  }

  async getAllTemplates(
    type?: string,
    name?: string,
    status?: string
  ): Promise<Response<DashboardTemplateListResponse[]>> {
    const response = await axios.get(`${this.baseUrl}/templates`, {
      params: { type, name, status }
    });
    return response.data;
  }

  async getTemplateById(id: string): Promise<any> {
    const serviceURL = `${this.baseUrl}/templates/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async saveTemplate(templateData: any) {
    const serviceUrl = `${this.baseUrl}/save-template`;
    const response = await axios.post(serviceUrl, templateData);
    return response.data;
  }

  async updateTemplate(templateData: any) {
    const serviceUrl = `${this.baseUrl}/save-template`;
    const response = await axios.post(serviceUrl, templateData);
    return response.data;
  }

  async deleteDashboardTemplate(id: string) {
    const serviceUrl = `${this.baseUrl}/delete-template/${id}`;
    return axios.delete(serviceUrl);
  }

  async duplicateTemplateById(id: string) {
    const serviceUrl = `${this.baseUrl}/duplicate-template`;
    const response = await axios.post(serviceUrl, {
      idTemplate: id
    });
    return response.data;
  }
}
